interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages = Array.from({ length: total }, (_, index) => index + 1);

  return (
    <div className="flex items-center justify-center gap-1.5 flex-wrap mt-8">
      <button
        type="button"
        disabled={current <= 1}
        onClick={() => onChange(current - 1)}
        className="h-9 px-3 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-accent-400 hover:text-accent-600 transition-colors disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer flex items-center gap-1 whitespace-nowrap"
      >
        <i className="ri-arrow-left-s-line w-4 h-4 flex items-center justify-center"></i>
        上一页
      </button>
      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          className={`w-9 h-9 rounded-md text-sm font-label transition-colors cursor-pointer ${
            page === current
              ? 'bg-primary-500 text-background-50'
              : 'border border-background-300 text-foreground-700 hover:border-accent-400 hover:text-accent-600'
          }`}
        >
          {page}
        </button>
      ))}
      <button
        type="button"
        disabled={current >= total}
        onClick={() => onChange(current + 1)}
        className="h-9 px-3 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-accent-400 hover:text-accent-600 transition-colors disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer flex items-center gap-1 whitespace-nowrap"
      >
        下一页
        <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center"></i>
      </button>
    </div>
  );
}